<template>
	<div class="initial-proposal-details" v-loading="is_loading" element-loading-text="Please Wait, Optimizing Proposal Page..." element-loading-background="rgba(255, 255, 255, 0.8)">
		<base-header class="pb-6">
				<b-row align-v="center" class="py-3">
						<b-col cols="12" md="6" class="mb-2">
							<div class="d-flex align-items-center">
								<div>
									<p class="text-muted">Detail</p>
									<h2 class="listing-title mb-0">Initial Proposal ID : {{ _gHlp.getValue(proposal, 'psal_id', 'N/A') }}</h2>
									<span class="badge badge-secondary px-3">Created By : {{ _gHlp.getValue(proposal, 'psal_created_by_detail.name', 'N/A') }}</span>
								</div>
								<div class="px-3">
									<MessagingBoxButton v-if="!is_loading" :type="'proposal'" :profile="proposal" />
								</div>
							</div>
						</b-col>
						<b-col cols="12" md="6" class="mb-2">
							<div class="d-flex flex-column align-items-start align-items-md-end">
								<el-button name="customer" type="primary" size="mini" icon="fa fa-arrow-left" class="py-1 mb-2" @click="goToCustomer">
									<span class="ml-2">Customer : {{ _gHlp.getValue(customer, 'name', 'N/A') | formatUserName(25) }}</span>
								</el-button>
								<el-button v-if="!is_loading" name="send_kyc" type="text"  class="py-1 mb-2" :icon="paper_plane_color" @click="sendKycToCustomer">
									<u class="ml-2 text-dark">Send KYC to customer</u>
								</el-button>
							</div>
						</b-col>
				</b-row>
		</base-header>
		<b-container fluid class="mt--6">
			<el-tabs v-model="current_tab" @tab-click="handleTabClick">
				<el-tab-pane label="DRAFT PROPOSAL" name="ccris_track">
					<CcrisTrackPage :proposal="proposal" :banks="banks" :customer="customer" :customer_ctos="customer_ctos" />
				</el-tab-pane>
				<el-tab-pane label="APPROVED PROPOSAL" name="proposal">
					<ProposalTabPage :proposal="proposal" :customer="customer" :customer_ctos="customer_ctos" />
				</el-tab-pane>
				<el-tab-pane label="FINAL PROPOSAL" name="final_proposal">
					<FinalProposalPage :proposal="proposal" :finalProposal="finalProposal" :banks="banks" :customer="customer" :customer_ctos="customer_ctos" />
				</el-tab-pane>
			</el-tabs>
			<ShareProposalModal :show_share_proposal.sync="modals.show_share_proposal" />
		</b-container>
	</div>
</template>
<script>
import { Tabs, TabPane, Button, Empty } from 'element-ui'
import { services} from '@/assets/js/httpImports.js'
import { cloneDeep } from 'lodash'
import initialProposalEventBus from '@/assets/js/EventBus/initialProposalEventBus.js'
import CcrisTrackPage from '@/views/InitialProposal/SubDetails/CcrisTrackPage'
import FinalProposalPage from '@/views/InitialProposal/SubDetails/FinalProposalPage'
import ProposalTabPage from '@/views/InitialProposal/SubDetails/ProposalTabPage'
import ShareProposalModal from '@/views/InitialProposal/Modals/ShareProposalModal'
import MessagingBoxButton from '@/views/Messaging/MessagingBoxButton'

import { mapActions, mapState } from 'pinia'
import { useInitialProposalStore } from '@/stores/initialProposalStore'
import { useCustomerStore } from '@/stores/customerStore'
import { useCreditReportStore } from '@/stores/creditReportStore'
import { useLookupStore } from '@/stores/lookupStore'
import { useInvinityStore } from '@/stores/invinityStore'
import { useConfigStore } from '@/stores/configStore'
import { useMessagingStore } from '@/stores/messagingStore'

export default {
	components: {
		CcrisTrackPage,
		ProposalTabPage,
		FinalProposalPage,
		ShareProposalModal,
		MessagingBoxButton,
		[Button.name]: Button,
		[Tabs.name]: Tabs,
		[TabPane.name]: TabPane
	},
	data() {
		return {
			proposal: null,
			finalProposal: null,
			customer: null,
			customer_ctos: null,
			current_tab: 'ccris_track',
			paper_plane_color: 'fa fa-paper-plane text-dark',
			modals: {
				show_share_proposal: false
			},
			kyc_access_token: localStorage.kyc_token != null ? JSON.parse(localStorage.kyc_token) : null,
		}
	},
	created(){
		initialProposalEventBus.$on('refresh-proposal-detail', this.initPage);
		this.initPage()
	},
	mounted(){
		if(!_gHlp.isEmpty(this.$route.query.active)){
			this.current_tab = this.$route.query.active;
		}
	},
	beforeUnmount(){
		this.resetProposalStore();
		this.resetCustomerStore();
	},
  beforeDestroy() {
    initialProposalEventBus.$off('refresh-proposal-detail', this.initPage)
  },
	computed: {
		...mapState(useInitialProposalStore, ['kyc_link_status']),
		...mapState(useCustomerStore, ['current_customer']),
		...mapState(useCreditReportStore, ['creditReportSummary']),
		...mapState(useLookupStore, ['banks']),
		is_loading(){
			return _gHlp.isLoading('fetch_proposal')
		}
	},
	watch: {
		kyc_link_status: {
			handler(newVal){
				this.paper_plane_color = 'fa fa-paper-plane '+(!_gHlp.isEmpty(newVal) ? newVal : 'text-dark')
			},
			immediate: true
		},
		current_customer: {
			handler(newVal){
				if (newVal) {
					this.customer = newVal
				}
			},
			immediate: true
		},
		creditReportSummary: {
			handler(newVal){
				if (newVal) {
					this.customer_ctos = newVal
				}
			},
			immediate: true
		}
	},
	methods: {
		...mapActions(useInitialProposalStore, ['updateProposalIncome','getProposal','resetProposalStore']),
		...mapActions(useCustomerStore, ['getCustomer','getEligibility','resetCustomerStore']),
		...mapActions(useCreditReportStore, ['getCreditReportSummary']),
		...mapActions(useInvinityStore, ['getInvSummary']),
		...mapActions(useMessagingStore, ['getProfileListMessagesSummaries']),
		async initPage(){
			_gHlp.setLoading('fetch_proposal')
			_gHlp.setLoading('fetch_proposal_customer')
			this.getProposal(this.$route.params.psal_id).then(async (resp) => {
				this.proposal = cloneDeep(resp)
				this.finalProposal = null
				//PROPOSAL FINAL
				if(!_gHlp.isEmpty(_gHlp.getValue(resp,'final_psal_id'))){
					_gHlp.setLoading('fetch_proposal_final')
					this.getProposal(_gHlp.getValue(resp,'final_psal_id')).then(async (resp) => {
						this.finalProposal = cloneDeep(resp)
						_gHlp.removeLoading('fetch_proposal_final')	
					}).catch(err=>{
						_gHlp.removeLoading('fetch_proposal_final')
					})
				}

				//INVINITY
				if(!_gHlp.isEmpty(_gHlp.getValue(resp,'psal_invinity_id'))){
					_gHlp.setLoading('fetch_inv_summary')
					this.getInvSummary(this.proposal.psal_id).then(resp=>{
						_gHlp.removeLoading('fetch_inv_summary')	
					}).catch(err=>{
						_gHlp.removeLoading('fetch_inv_summary')
					})
				}

				//CREDIT REPORT
				_gHlp.removeLoading('fetch_proposal')
				this.getCreditReportSummary({credit_report_cust_id: this.proposal.psal_customer_id}).then(resp=>{
					_gHlp.removeLoading('fetch_credit_report')
				}).catch(err=>{
					_gHlp.removeLoading('fetch_credit_report')
				})

				
				await this.getCustomer(this.proposal.psal_customer_id)
				this.getEligibility()
				
				_gHlp.removeLoading('fetch_proposal')
				_gHlp.removeLoading('fetch_proposal_customer')
			}).catch(err=>{
				_gHlp.removeLoading('fetch_proposal')
				_gHlp.removeLoading('fetch_proposal_customer')
			})

		},
		handleTabClick(obj, e){
			if(this.$route.query.active !== obj.name){
				const query = { ...this.$route.query, active: obj.name };
				this.$router.push({path: this.$route.path, query});
			}
		},
		sendKycToCustomer() {
			if (!this.kyc_access_token || this.kyc_access_token.access_token == null) {
				_gNotif.notifyError('<b>KYC token is invalid. Please login again.', 2000);
			}
			else {
				const url = services.kyc_vue + '/customer/sendCustomersForm/' + this.proposal.psal_customer_id + `/IM2U V2/` + this.kyc_access_token.access_token;
				window.open(url, '_blank');
			}
		},
		goToCustomer(){
			this.$router.push({path:'/customerProfileDetails/'+this.proposal.psal_customer_id})
		}
	}
}
</script>